<div class="social-group">
  <!-- EMAIL SIGNIN -->
  <button class="social-action" (click)="handleEmailSignIn()">
    <img
      src="../../../../assets/images/signin-email-icon.png"
      alt=""
      class="social-icon"
    />
    <div class="social-text">Continue with email</div>
  </button>

  <!-- GOOGLE SIGNIN -->
  <button class="social-action" (click)="signInWithGoogle()">
    <img
      src="../../../../assets/images/signin-google-icon.png"
      alt=""
      class="social-icon"
    />
    <div class="social-text">Continue with Google</div>
  </button>
</div>
